export enum Roles {
    Client = 'Client',
}

export const RolesMap = {
    [Roles.Client]: Roles.Client,
};
